import * as React from "react";
import { hydrate } from "react-dom";
import { App, BrowserContentProvider } from "../components/App";
import "./globals";

const NODE_ID = "root";

let node = document.getElementById(NODE_ID);

if (!node) {
  node = document.body.appendChild(document.createElement("div"));
  node.id = NODE_ID;
}

try {
  hydrate(
    <BrowserContentProvider>
      {props => <App {...props} />}
    </BrowserContentProvider>,
    node
  );
} catch (error) {
  console.error("There was an error mounting the application", error);
}
